import { envVars } from './envVars';

const getValueOrDefault = (value: string, defaultValue: string): string => {
	return new RegExp('%%%\\w+%%%').test(value) ? defaultValue : value;
};

export const ApiConfig = {
	headers: {
		//DEV
		accept: getValueOrDefault(
			envVars.api.headers.accept,
			'application/vnd.mbcpcjEcommerce+json; version=1.001.000'
		),
		'ocp-apim-subscription-key': getValueOrDefault(
			envVars.api.headers['ocp-apim-subscription-key'],
			// '189a88e4b8294aef90ef52cef6c92268',
			'86e2833c0af74d0c902fd06be73a9833'
		),
		// IN
		// accept: getValueOrDefault(
		//	envVars.api.headers.accept,
		//	'application/vnd.mbcpcjEcommerce+json; version=3.001.000'
		// ),
		// 'ocp-apim-subscription-key': getValueOrDefault(
		//	envVars.api.headers['ocp-apim-subscription-key'],
		//	'557963a4de4e4816aa29ce431988ee78'
		// ),
		'content-type': getValueOrDefault(envVars.api.headers['content-type'], 'application/json'),
	},
	url: getValueOrDefault(envVars.api.url, 'https://mbcplab.azure-api.net/cj/Ecommerce/'),
};

export const LoggerConfig = {
	debug: getValueOrDefault(envVars.logger.debug, 'true') === 'true',
	error: getValueOrDefault(envVars.logger.error, 'true') === 'true',
	log: getValueOrDefault(envVars.logger.log, 'true') === 'true',
};
